export default __webpack_public_path__ + "static/media/safari_settings_partial.dda1ffd8.png";